<template>
	<form :class="['bundle', { 'bundle--3': ver === '3' }]">
		<legend
			v-if="ver === '3' && title"
			v-text="title"
			class="bundle__title"
		/>
		<ul
			:class="[
				'list bundle__list',
				{
					'list--vertical': verticalUi,
				},
			]"
		>
			<li
				v-for="(item, idx) in radioList"
				:key="idx"
				class="list__item bundle__list-item"
			>
				<label
					:class="[
						'radio-box bundle__label',
						{ 'bundle__label--checked': isChecked(item[keyName]) },
					]"
				>
					<input
						:value="item[keyName]"
						:checked="isChecked(item[keyName])"
						:disabled="isDisabled(item[keyName])"
						type="radio"
						:class="[
							'radio-box__input',
							inputClass,
							'bundle__input',
						]"
						@change="onChange(item[keyName], item[valueName])"
						@keydown.enter="$emit('enter')"
					/>
					<span
						:class="[
							'radio-box__text bundle__item-title',
							{
								'radio-box__text--checked': isChecked(
									item[keyName]
								),
								'radio-box__text--disabled': isDisabled(
									item[keyName]
								),
								large: size === 'lg',
							},
						]"
						>{{ item[valueName] }}</span
					>
				</label>
			</li>
		</ul>
	</form>
</template>
<script>
	export default {
		name: 'RadioList',
		props: {
			inputClass: {
				type: String,
				default: '',
			},
			radioList: {
				type: Array,
				required: true,
			},
			value: {
				type: [String, Number, Object, Boolean],
				default: null,
			},
			keyName: {
				type: String,
				default: 'id',
			},
			valueName: {
				type: String,
				default: 'value',
			},
			disabled: {
				type: [Boolean, String],
				default: false,
			},
			disabledIds: {
				type: Array,
				default: () => [],
			},
			verticalUi: {
				type: Boolean,
				default: false,
			},
			ver: {
				type: String,
				default: null,
			},
			title: {
				type: String,
				default: null,
			},
			size: {
				type: String,
				default: 'md',
			},
		},
		computed: {
			isChecked() {
				return value => value === this.value;
			},
			isDisabled() {
				return id =>
					(this.disabled &&
						this.disabledIds.some(
							disabledId => disabledId === id
						)) ||
					this.disabled === 'all';
			},
		},
		methods: {
			onChange(id, name) {
				this.$emit('inputWithOptional', {
					id,
					name,
					lastId: this.value,
				});
				this.$emit('input', id);
			},
		},
	};
</script>
<style lang="scss" scoped>
	FORM {
		.list {
			display: inline-flex;
			flex-wrap: wrap;
			align-items: center;
			padding: 0;
		}

		.list--vertical {
			flex-direction: column;

			.list__item {
				margin-right: 0;
			}
		}

		.list__item {
			margin-right: 30px;

			&:last-child {
				margin-right: 0;
			}
		}

		.radio-box {
			cursor: pointer;
			display: flex;
			align-items: center;
			margin-left: -4px;
			padding: 7px 4px;
			border-radius: 4px;
			font-size: 0.875rem;

			&:hover {
				background: #f4f7fa;
			}

			&:active {
				background: #dfe6ee;
			}
		}

		.radio-box__input {
			cursor: pointer;
			display: block;

			&:focus {
				outline: 1px solid #0099fa;
			}
		}

		.radio-box__text {
			cursor: pointer;
			display: block;
			margin: 0 0 0 8px;
			color: #222;
			font-size: 0.875rem;

			&.large {
				font-size: 1.2rem;
			}
		}

		.radio-box__text--checked {
			font-weight: 700;
			&.large {
				font-size: 1.4rem;
			}
		}

		.radio-box__text--disabled {
			color: #7a839b;
		}
	}

	.bundle--3 {
		display: flex;
		background: lightblue;
		align-items: center;

		.bundle__title {
			padding: 0 12px;
		}

		.bundle__list {
			display: flex;
		}

		.bundle__list-item {
			margin: 0;
		}

		.bundle__label {
			display: block;
			height: 36px;
			margin: 0;
			line-height: 34px;
			background: white;
			padding: 0 12px;
			border-radius: 0;
			border: 1px solid lightblue;
			border-left: 0;

			&--checked {
				box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
			}
		}

		.bundle__input {
			display: none;
		}

		.bundle__item-title {
			margin: 0;
		}
	}
</style>
